export default "__VITE_ASSET__Dqey_rDd__"